// extracted by mini-css-extract-plugin
export var cardIcon = "_a5-5";
export var cardIconUnframed = "_a5-9";
export var checkboxCard = "_a5-0";
export var checkboxCardSelected = "_a5-4";
export var disabled = "_a5-2";
export var interactive = "_a5-1";
export var outerBorder = "_a5-3";
export var spacerMedium = "_a5-8";
export var spacerSmall = "_a5-7";
export var spacerXsmall = "_a5-6";